module.exports = __webpack_public_path__ + "media/images/writer/monitor/mv-img@2x-34e5c12c881baffbac586c9eb0bb3dc5.png";